import { render, staticRenderFns } from "./DraftsPage.vue?vue&type=template&id=04ba21f5&"
import script from "./DraftsPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./DraftsPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./DraftsPage.vue?vue&type=style&index=0&id=04ba21f5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports